import { render, staticRenderFns } from "./ParentLayout.vue?vue&type=template&id=54fe82e8&scoped=true&"
import script from "./ParentLayout.vue?vue&type=script&lang=js&"
export * from "./ParentLayout.vue?vue&type=script&lang=js&"
import style0 from "./ParentLayout.vue?vue&type=style&index=0&id=54fe82e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fe82e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout,VSpacer})
